import React from 'react'
import { localsMessages } from '../utility/getTemplateData'

export default React.createClass({

	propTypes: {
		label: React.PropTypes.string
	},

	getInitialState () {
		return {};
	},

	render () {
		const guestMessages = localsMessages('guest/payCreditOrDebit') || {}
		const payCreditOrDebit = guestMessages.label && guestMessages.label.payCreditOrDebit || ''

		return (
			<div className="row" style={{ maxWidth:400, margin: '0 auto' }}>
				<div className="col-xs-12 col-sm-12 col-md-12" style={{ padding: 0}}>
					<h3 className="donate_credit_debit" id="payCreditOrDebitTxt">{payCreditOrDebit}</h3>
				</div>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./guest/payCreditOrDebit.js